// extracted by mini-css-extract-plugin
module.exports = {"filterCollapse":"filterCollapse-2MP","toggleIcon":"toggleIcon-2sv","toggleIconUp":"toggleIconUp-1Li"};